import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {OperationRoomItem} from "../types/operation";

const COLLECTION_ID = "operation_room"
const databases = new Databases(client);

export const operationRoomsService = {

  async list(queries: string[] = [], limit: number = 100): Promise<OperationRoomItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      return response.documents.map(doc => doc as unknown as OperationRoomItem);

    } catch (error) {
      throw error;
    }
  },
}